<template>
  <div v-show="show">
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t("general.add")}}
        </el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" stripe highlight-current-row border style="width: 100%"
      :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('healthIns5.submission_date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.apply_date}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns5.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns5.birthday')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.birthday }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns5.income')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.s_income }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}</el-button>
          <!-- <el-button size="mini" type="success" icon="el-icon-view" @click="preview(scope.$index, scope.row)" plain>
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!--adding new-->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="90%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="170px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition">
        <el-input type="hidden" v-model="ruleForm.id" />
        <el-row>
          <el-form-item :label="$t('healthIns5.submission_date')" prop="apply_date" style="margin-left:50px">
            <el-date-picker v-model="ruleForm.apply_date" size="mini" value-format="yyyy-MM-dd"
              style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns5.submission_date')">
            </el-date-picker>
          </el-form-item>
        </el-row>
        <el-collapse accordion>
          <el-collapse-item :title="$t('healthIns5.ins_info')" name="1" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns5.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id" clearable style="margin-left:10px;width: 185px"
                      size="mini" @change="employeeIdSelected" :placeholder="$t('general.select')">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.name')" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.gender')" prop="gender" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.gender" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('general.select')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.acq_date')" prop="emp_ins_begin_day" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.emp_ins_begin_day" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.acq_date')" readonly>
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.reference_no')" prop="reference_no" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.reference_no" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.reference_no')"></el-input>
                    <el-button class="el-icon-info" type="text" @click="referenceHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item>
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.birthday')" prop="birthday" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.birthday" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns5.birthday')"
                      readonly></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.mynum')" prop="mynum" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.mynum" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.mynum')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.income')" prop="income" style="margin-left:50px">
                    <el-input @change="handleToMoney" prefix-icon="el-icon-edit" v-model="ruleForm.income" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>&nbsp;円
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--Spouse Input -->
          <el-collapse-item :title="$t('healthIns5.spouse')" name="2" style="margin-left:10px">
            <el-row>

              <el-form-item :label="$t('healthIns5.deliver_date')" prop="s_send_date" style="margin-left:50px">
                <el-date-picker v-model="ruleForm.s_send_date" size="mini" value-format="yyyy-MM-dd"
                  style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns5.deliver_date')">
                </el-date-picker>
              </el-form-item>

              <el-form-item prop="s_to2">
                <el-checkbox prefix-icon="el-icon-edit" v-model="ruleForm.s_to2" size="mini"
                  style="margin-left:10px;width: 185px">{{$t("healthIns5.third_person")}}</el-checkbox>
              </el-form-item>

            </el-row>
            <el-row>
              <el-col :span="8">
                <div>

                  <el-form-item :label="$t('healthIns5.s_name')" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_name" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.s_name')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.birthday')" prop="birthday" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.s_birthday" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns5.birthday')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.foreign_name')" prop="s_foreigner_name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_foreigner_name" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.foreign_name')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.address')" prop="together" style="margin-left:50px">
                    <el-select v-model="ruleForm.s_together" clearable style="margin-left:10px;width: 185px" size="mini"
                      :placeholder="$t('general.select')">
                      <el-option v-for="item in together" :key="item.id" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.phone')" prop="tel_type" style="margin-left:50px">
                    <el-select v-model="ruleForm.s_tel_type" clearable style="margin-left:10px;width: 185px" size="mini"
                      :placeholder="$t('general.select')">
                      <el-option v-for="item in tel_type" :key="item.id" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.type')" prop="applicate_type" style="margin-left:50px">
                    <el-select v-model="ruleForm.s_applicate_type" clearable style="margin-left:10px;width: 185px"
                      size="mini" :placeholder="$t('general.select')">
                      <el-option v-for="item in applicate_type" :key="item.id" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                  <el-form-item :label="$t('healthIns5.s_name_pho')" prop="s_name_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_name_frgn" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.s_name_pho')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.mynum')" prop="s_mynum" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_mynum" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.mynum')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.foreign_name_pho')" prop="s_foreigner_name_frgn"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_foreigner_name_frgn" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.foreign_name_pho')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.postal_code')" prop="post" v-if="ruleForm.s_together === '別居'"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_post" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.postal_code')"></el-input>
                  </el-form-item>

                  <el-form-item v-if="ruleForm.s_together !== '別居' ">
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.phone')" prop="s_tel" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_tel" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.phone_ex')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.oversea_type')" prop="oversea" style="margin-left:50px">
                    <el-select v-model="ruleForm.s_oversea" clearable style="margin-left:10px;width: 185px" size="mini"
                      :placeholder="$t('general.select')">
                      <el-option v-for="item in oversea" :key="item.id" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div>

                  <el-form-item> <span> <br /> </span> </el-form-item>

                  <el-form-item :label="$t('healthIns5.relation')" prop="relation" style="margin-left:50px">
                    <el-select v-model="ruleForm.s_relation" clearable style="margin-left:10px;width: 185px" size="mini"
                      :placeholder="$t('general.select')">
                      <el-option v-for="item in s_relation" :key="item.id" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.nationality')" prop="s_country" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_country" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.nationality')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.address')" prop="s_address" 　v-if="ruleForm.s_together === '別居'"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_address" type="textarea" :rows="4.5"
                      size="mini" style="margin-left:10px;width: 185px;" :placeholder="$t('healthIns5.address')">
                    </el-input>
                  </el-form-item>

                  <el-form-item v-if="ruleForm.s_together !== '別居' ">
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item v-if="ruleForm.s_together !== '別居' ">
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.remark')" prop="s_remark" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_remark" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.remark')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row align="center" v-if="ruleForm.s_applicate_type === '該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium; margin-left:50px;">***{{$t("healthIns5.applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.s_applicate_type === '該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.d_become_date')" prop="become_date" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.s_become_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 160px" type="date" :placeholder="$t('healthIns5.d_become_date')">
                  </el-date-picker>
                  <el-button class="el-icon-info" type="text" @click="s_become_date_hint"></el-button>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.s_reason" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in s_become_reason" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.employed')" prop="occupation" style="margin-left:50px">
                  <el-select v-model="ruleForm.s_occupation" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in s_occupation" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item v-if="ruleForm.s_reason !== 'その他'">
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.s_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.other_occupation')" prop="other_occupation"
                  v-if="ruleForm.s_occupation === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_occupation')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.income')" prop="income" style="margin-left:50px"
                  v-if="ruleForm.s_occupation === 'パート'　|| ruleForm.s_occupation === '年金受給者' ">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_income" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.income')"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.income')" prop="income" style="margin-left:50px"
                  v-if="ruleForm.s_occupation === 'その他'">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_income" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.income')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.s_applicate_type === '非該当' || ruleForm.s_applicate_type === '変更'  ">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium; margin-left:50px;">***{{$t("healthIns5.not_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.s_applicate_type === '非該当' || ruleForm.s_applicate_type === '変更'  ">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.d_change_date')" prop="become_date" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.s_become_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 160px" type="date" :placeholder="$t('healthIns5.d_change_date')">
                  </el-date-picker>
                  <el-button class="el-icon-info" type="text" @click="s_change_date_hint"></el-button>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.s_reason" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in s_change_reason" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.s_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.death_date')" prop="s_death_date" v-if="ruleForm.s_reason === '死亡'"
                  style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.s_death_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns5.death_date')">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.s_oversea === '海外特例要件該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium;margin-left:50px;">***{{$t("healthIns5.oversea_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.s_oversea === '海外特例要件該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.oversea_become_date')" prop="oversea_date"
                  style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.s_oversea_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date"
                    :placeholder="$t('healthIns5.oversea_become_date')"></el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.s_oversea_reason" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea_become_reason" :key="item.id" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.s_oversea_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_oversea_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.s_oversea === '海外特例要件非該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium;margin-left:50px;">***{{$t("healthIns5.oversea_not_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.s_oversea === '海外特例要件非該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.oversea_change_date')" prop="oversea_date"
                  style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.s_oversea_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date"
                    :placeholder="$t('healthIns5.oversea_change_date')"></el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.s_oversea_reason" style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea_change_reason" :key="item.id" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.s_oversea_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_oversea_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.domestic_transfer_date')" prop="oversea_transfer_date"
                  　v-if="ruleForm.s_oversea_reason === '国内転'" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.s_oversea_transfer_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date"
                    :placeholder="$t('healthIns5.domestic_transfer_date')"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--Dependent1 Input -->
          <el-collapse-item :title="$t('healthIns5.dependent1')" name="3" style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.ins_last_name')" prop="d_last_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_name_last" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_last_name')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.ins_last_name_pho')" prop="d_last_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_name_last_frgn" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_last_name_pho')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.birthday')" prop="d_birthday" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d1_birthday" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns5.birthday')">
                  </el-date-picker>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.address')" prop="together" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_together" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in together" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.type')" prop="applicate_type" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_applicate_type" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in applicate_type" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.ins_first_name')" prop="d_first_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_name_first" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_first_name')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.ins_first_name_pho')" prop="d_first_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_name_first_frgn" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_first_name_pho')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.gender')" prop="gender" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_gender" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in gender" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-if="ruleForm.d1_together !== '別居' ">
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.postal_code')" prop="post" 　v-if="ruleForm.d1_together === '別居' "
                  style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_post" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.postal_code')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.oversea_type')" prop="oversea" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_oversea" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.remark')" prop="remark" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_remark" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.remark')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.relation')" prop="relation" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_relation" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in d_relation" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.address')" prop="address" 　v-if="ruleForm.d1_together === '別居'"
                  style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_address" type="textarea" :rows="4"
                    size="mini" style="margin-left:10px;width: 185px;" :placeholder="$t('healthIns5.address')">
                  </el-input>
                </el-form-item>

                <el-form-item v-if="ruleForm.d1_together !== '別居' ">
                  <span>
                    <br />
                  </span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d1_applicate_type === '該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium; margin-left:50px;">***{{$t("healthIns5.applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d1_applicate_type === '該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.d_become_date')" prop="become_date" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d1_become_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 160px" type="date" :placeholder="$t('healthIns5.d_become_date')">
                  </el-date-picker>
                  <el-button class="el-icon-info" type="text" @click="s_become_date_hint"></el-button>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_reason" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in d_become_reason" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.employed')" prop="occupation" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_occupation" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in d_occupation" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item v-if="ruleForm.d1_reason !== 'その他'">
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d1_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.other_occupation')" prop="other_occupation"
                  v-if="ruleForm.d1_occupation === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_occupation')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.income')" prop="income"
                  v-if="ruleForm.d1_occupation === 'パート'　|| ruleForm.d1_occupation === '年金受給者' ">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_income" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.income')"></el-input>
                </el-form-item>

                <el-form-item prop="school_year" v-if="ruleForm.d1_occupation === '高・大学生' " style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_school_year" size="mini"
                    style="margin-left:10px;width: 100px" placeholder="00"></el-input>
                  &emsp13; {{$t("healthIns5.grade")}}
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.income')" prop="income" v-if="ruleForm.d1_occupation === 'その他'"
                  style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_income" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.income')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d1_applicate_type === '非該当' || ruleForm.d1_applicate_type === '変更'  ">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium;margin-left:50px;">***{{$t("healthIns5.not_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d1_applicate_type === '非該当' || ruleForm.d1_applicate_type === '変更'  ">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.d_change_date')" prop="become_date" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d1_become_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 160px" type="date" :placeholder="$t('healthIns5.d_change_date')">
                  </el-date-picker>
                  <el-button class="el-icon-info" type="text" @click="s_change_date_hint"></el-button>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_reason" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in d_change_reason" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d1_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d1_oversea === '海外特例要件該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium; margin-left:50px;">***{{$t("healthIns5.oversea_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d1_oversea === '海外特例要件該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_oversea_reason" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea_become_reason" :key="item.id" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d1_oversea_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_oversea_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d1_oversea === '海外特例要件非該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium;">***{{$t("healthIns5.oversea_not_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d1_oversea === '海外特例要件非該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_oversea_reason" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea_change_reason" :key="item.id" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d1_oversea_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_oversea_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.domestic_transfer_date')" prop="oversea_transfer_date"
                  　v-if="ruleForm.d1_oversea_reason === '国内転'" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d1_oversea_transfer_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date"
                    :placeholder="$t('healthIns5.domestic_transfer_date')"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--Dependent2 Input -->
          <el-collapse-item :title="$t('healthIns5.dependent2')" name="4" style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.ins_last_name')" prop="d_last_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_name_last" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_last_name')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.ins_last_name_pho')" prop="d_last_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_name_last_frgn" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_last_name_pho')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.birthday')" prop="d_birthday" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d2_birthday" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns5.birthday')">
                  </el-date-picker>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.address')" prop="together" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_together" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in together" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.type')" prop="applicate_type" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_applicate_type" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in applicate_type" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.ins_first_name')" prop="d_first_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_name_first" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_first_name')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.ins_first_name_pho')" prop="d_first_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_name_first_frgn" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_first_name_pho')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.gender')" prop="gender" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_gender" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in gender" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-if="ruleForm.d2_together !== '別居' ">
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.postal_code')" prop="post" 　v-if="ruleForm.d2_together === '別居' "
                  style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_post" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.postal_code')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.oversea_type')" prop="oversea" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_oversea" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.remark')" prop="remark" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_remark" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.remark')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.relation')" prop="relation" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_relation" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in d_relation" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.address')" prop="address" 　v-if="ruleForm.d2_together === '別居'"
                  style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_address" type="textarea" :rows="4"
                    size="mini" style="margin-left:10px;width: 185px;" :placeholder="$t('healthIns5.address')">
                  </el-input>
                </el-form-item>

                <el-form-item v-if="ruleForm.d2_together !== '別居' ">
                  <span>
                    <br />
                  </span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d2_applicate_type === '該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium; margin-left:50px;">***{{$t("healthIns5.applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d2_applicate_type === '該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.d_become_date')" prop="become_date" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d2_become_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 160px" type="date" :placeholder="$t('healthIns5.d_become_date')">
                  </el-date-picker>
                  <el-button class="el-icon-info" type="text" @click="s_become_date_hint"></el-button>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_reason" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in d_become_reason" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.employed')" prop="occupation" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_occupation" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in d_occupation" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item v-if="ruleForm.d2_reason !== 'その他'">
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d2_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.other_occupation')" prop="other_occupation"
                  v-if="ruleForm.d2_occupation === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_occupation')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.income')" prop="income" style="margin-left:50px"
                  v-if="ruleForm.d2_occupation === 'パート'　|| ruleForm.d2_occupation === '年金受給者' ">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_income" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.income')"></el-input>
                </el-form-item>

                <el-form-item prop="school_year" v-if="ruleForm.d2_occupation === '高・大学生' " style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_school_year" size="mini"
                    style="margin-left:10px;width: 100px" placeholder="00"></el-input>
                  &emsp13; {{$t("healthIns5.grade")}}
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.income')" prop="income" v-if="ruleForm.d2_occupation === 'その他'"
                  style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_income" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.income')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d2_applicate_type === '非該当' || ruleForm.d2_applicate_type === '変更'  ">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium;margin-left:50px;">***{{$t("healthIns5.not_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d2_applicate_type === '非該当' || ruleForm.d2_applicate_type === '変更'  ">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.d_change_date')" prop="become_date" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d2_become_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 160px" type="date" :placeholder="$t('healthIns5.d_change_date')">
                  </el-date-picker>
                  <el-button class="el-icon-info" type="text" @click="s_change_date_hint"></el-button>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_reason" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in d_change_reason" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d2_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d2_oversea === '海外特例要件該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium;margin-left:50px;">***{{$t("healthIns5.oversea_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d2_oversea === '海外特例要件該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_oversea_reason" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea_become_reason" :key="item.id" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d1_oversea_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_oversea_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d2_oversea === '海外特例要件非該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium; margin-left:50px;">***{{$t("healthIns5.oversea_not_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d2_oversea === '海外特例要件非該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_oversea_reason" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea_change_reason" :key="item.id" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d2_oversea_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_oversea_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.domestic_transfer_date')" prop="oversea_transfer_date"
                  　v-if="ruleForm.d2_oversea_reason === '国内転'" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d2_oversea_transfer_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date"
                    :placeholder="$t('healthIns5.domestic_transfer_date')"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!--edit-->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="90%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="170px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition">

        <el-input type="hidden" v-model="ruleForm.id" />
        <el-row>
          <el-form-item :label="$t('healthIns5.submission_date')" prop="apply_date" style="margin-left:50px">
            <el-date-picker v-model="ruleForm.apply_date" size="mini" value-format="yyyy-MM-dd"
              style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns5.submission_date')">
            </el-date-picker>
          </el-form-item>
        </el-row>
        <el-collapse accordion>
          <el-collapse-item :title="$t('healthIns5.ins_info')" name="1" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns5.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id" clearable style="margin-left:10px;width: 185px"
                      size="mini" @change="employeeIdSelected" :placeholder="$t('general.select')">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.name')" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.gender')" prop="gender" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.gender" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('general.select')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.acq_date')" prop="emp_ins_begin_day" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.emp_ins_begin_day" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.acq_date')" readonly>
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.reference_no')" prop="reference_no" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.reference_no" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.reference_no')"></el-input>
                    <el-button class="el-icon-info" type="text" @click="referenceHint"></el-button>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item> <span> <br /> </span> </el-form-item>

                  <el-form-item :label="$t('healthIns5.birthday')" prop="birthday" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.birthday" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns5.birthday')"
                      readonly></el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.mynum')" prop="mynum" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.mynum" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.mynum')" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.income')" prop="income" style="margin-left:50px">
                    <el-input @change="handleToMoney" prefix-icon="el-icon-edit" v-model="ruleForm.income" size="mini"
                      style="margin-left:10px;width: 185px"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--Spouse Input -->
          <el-collapse-item :title="$t('healthIns5.spouse')" name="2" style="margin-left:10px">
            <el-row>
              <el-form-item :label="$t('healthIns5.deliver_date')" prop="s_send_date" style="margin-left:50px">
                <el-date-picker v-model="ruleForm.s_send_date" size="mini" value-format="yyyy-MM-dd"
                  style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns5.deliver_date')">
                </el-date-picker>
              </el-form-item>

              <el-form-item prop="s_to2">
                <el-checkbox prefix-icon="el-icon-edit" v-model="ruleForm.s_to2" size="mini"
                  style="margin-left:10px;width: 185px">{{$t("healthIns5.third_person")}}</el-checkbox>
              </el-form-item>

            </el-row>

            <el-row>
              <el-col :span="8">
                <div>
                  <el-form-item :label="$t('healthIns5.s_name')" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_name" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.s_name')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.birthday')" prop="birthday" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.s_birthday" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns5.birthday')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.foreign_name')" prop="s_foreigner_name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_foreigner_name" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.foreign_name')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.address')" prop="together" style="margin-left:50px">
                    <el-select v-model="ruleForm.s_together" clearable style="margin-left:10px;width: 185px" size="mini"
                      :placeholder="$t('general.select')">
                      <el-option v-for="item in together" :key="item.id" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.phone')" prop="tel_type" style="margin-left:50px">
                    <el-select v-model="ruleForm.s_tel_type" clearable style="margin-left:10px;width: 185px" size="mini"
                      :placeholder="$t('general.select')">
                      <el-option v-for="item in tel_type" :key="item.id" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.type')" prop="applicate_type" style="margin-left:50px">
                    <el-select v-model="ruleForm.s_applicate_type" clearable style="margin-left:10px;width: 185px"
                      size="mini" :placeholder="$t('general.select')">
                      <el-option v-for="item in applicate_type" :key="item.id" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div>

                  <el-form-item :label="$t('healthIns5.s_name_pho')" prop="s_name_frgn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_name_frgn" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.s_name_pho')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.mynum')" prop="s_mynum" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_mynum" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.mynum')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.foreign_name_pho')" prop="s_foreigner_name_frgn"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_foreigner_name_frgn" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.foreign_name_pho')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.postal_code')" prop="post" v-if="ruleForm.s_together === '別居' "
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_post" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.postal_code')"></el-input>
                  </el-form-item>

                  <el-form-item v-if="ruleForm.s_together !== '別居' " style="margin-left:50px">
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.phone')" prop="s_tel" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_tel" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.phone_ex')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.oversea_type')" prop="oversea" style="margin-left:50px">
                    <el-select v-model="ruleForm.s_oversea" clearable style="margin-left:10px;width: 185px" size="mini"
                      :placeholder="$t('general.select')">
                      <el-option v-for="item in oversea" :key="item.id" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div>

                  <el-form-item> <span> <br /> </span> </el-form-item>

                  <el-form-item :label="$t('healthIns5.relation')" prop="relation" style="margin-left:50px">
                    <el-select v-model="ruleForm.s_relation" clearable style="margin-left:10px;width: 185px" size="mini"
                      :placeholder="$t('general.select')">
                      <el-option v-for="item in s_relation" :key="item.id" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.nationality')" prop="s_country" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_country" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.nationality')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.address')" prop="s_address" 　v-if="ruleForm.s_together === '別居'"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_address" type="textarea" :rows="4.5"
                      size="mini" style="margin-left:10px;width: 185px;" :placeholder="$t('healthIns5.address')">
                    </el-input>
                  </el-form-item>

                  <el-form-item v-if="ruleForm.s_together !== '別居' ">
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item v-if="ruleForm.s_together !== '別居' ">
                    <span>
                      <br />
                    </span>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns5.remark')" prop="s_remark" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_remark" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.remark')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row align="center" v-if="ruleForm.s_applicate_type === '該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium; margin-left:50px;">***{{$t("healthIns5.applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.s_applicate_type === '該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.d_become_date')" prop="become_date" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.s_become_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 160px" type="date" :placeholder="$t('healthIns5.d_become_date')">
                  </el-date-picker>
                  <el-button class="el-icon-info" type="text" @click="s_become_date_hint"></el-button>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.s_reason" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in s_become_reason" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.employed')" prop="occupation" style="margin-left:50px">
                  <el-select v-model="ruleForm.s_occupation" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in s_occupation" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item v-if="ruleForm.s_reason !== 'その他'">
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason" style="margin-left:50px"
                  v-if="ruleForm.s_reason === 'その他'">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.other_occupation')" prop="other_occupation" style="
                  margin-left:50px" v-if="ruleForm.s_occupation === 'その他'">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_other_reason" size="mini "
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_occupation')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.income')" prop="income" style="margin-left:50px"
                  v-if="ruleForm.s_occupation === 'パート'　|| ruleForm.s_occupation === '年金受給者' ">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_income" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.income')"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.income')" prop="income" v-if="ruleForm.s_occupation === 'その他'"
                  style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_income" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.income')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.s_applicate_type === '非該当' || ruleForm.s_applicate_type === '変更'  ">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium;margin-left:50px;">***{{$t("healthIns5.not_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.s_applicate_type === '非該当' || ruleForm.s_applicate_type === '変更'  ">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.d_change_date')" prop="become_date" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.s_become_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 160px" type="date" :placeholder="$t('healthIns5.d_change_date')">
                  </el-date-picker>
                  <el-button class="el-icon-info" type="text" @click="s_change_date_hint"></el-button>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.s_reason" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in s_change_reason" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.s_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.death_date')" prop="s_death_date" v-if="ruleForm.s_reason === '死亡'"
                  style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.s_death_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns5.death_date')">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.s_oversea === '海外特例要件該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium; margin-left:50px;">***{{$t("healthIns5.oversea_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.s_oversea === '海外特例要件該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.oversea_become_date')" prop="oversea_date"
                  style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.s_oversea_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date"
                    :placeholder="$t('healthIns5.oversea_become_date')"></el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.s_oversea_reason" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea_become_reason" :key="item.id" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.s_oversea_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_oversea_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.s_oversea === '海外特例要件非該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium; margin-left:50px;">***{{$t("healthIns5.oversea_not_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.s_oversea === '海外特例要件非該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.oversea_change_date')" prop="oversea_date"
                  style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.s_oversea_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date"
                    :placeholder="$t('healthIns5.oversea_change_date')"></el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.s_oversea_reason" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea_change_reason" :key="item.id" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.s_oversea_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_oversea_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.domestic_transfer_date')" prop="oversea_transfer_date"
                  　v-if="ruleForm.s_oversea_reason === '国内転'" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.s_oversea_transfer_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date"
                    :placeholder="$t('healthIns5.domestic_transfer_date')"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--Dependent1 Input -->
          <el-collapse-item :title="$t('healthIns5.dependent1')" name="3" style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.ins_last_name')" prop="d_last_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_name_last" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_last_name')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.ins_last_name_pho')" prop="d_last_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_name_last_frgn" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_last_name_pho')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.birthday')" prop="d_birthday" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d1_birthday" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns5.birthday')">
                  </el-date-picker>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.address')" prop="together" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_together" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in together" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.type')" prop="applicate_type" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_applicate_type" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in applicate_type" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.ins_first_name')" prop="d_first_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_name_first" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_first_name')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.ins_first_name_pho')" prop="d_first_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_name_first_frgn" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_first_name_pho')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.gender')" prop="gender" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_gender" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in gender" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-if="ruleForm.d1_relation !==''　|| ruleForm.d1_together !== '別居' ">
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.postal_code')" prop="post" 　v-if="ruleForm.d1_together === '別居' "
                  style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_post" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.postal_code')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.oversea_type')" prop="oversea" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_oversea" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.remark')" prop="remark" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_remark" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.remark')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.relation')" prop="relation" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_relation" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in d_relation" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.address')" prop="address" 　v-if="ruleForm.d1_together === '別居'"
                  style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_address" type="textarea" :rows="4"
                    size="mini" style="margin-left:10px;width: 185px;" :placeholder="$t('healthIns5.address')">
                  </el-input>
                </el-form-item>

                <el-form-item v-if="ruleForm.d1_together !== '別居' ">
                  <span>
                    <br />
                  </span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d1_applicate_type === '該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium;margin-left:50px;">***{{$t("healthIns5.applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d1_applicate_type === '該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.d_become_date')" prop="become_date" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d1_become_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 160px" type="date" :placeholder="$t('healthIns5.d_become_date')">
                  </el-date-picker>
                  <el-button class="el-icon-info" type="text" @click="s_become_date_hint"></el-button>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_reason" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in d_become_reason" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.employed')" prop="occupation" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_occupation" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in d_occupation" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item v-if="ruleForm.d1_reason !== 'その他'">
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d1_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.other_occupation')" prop="other_occupation"
                  v-if="ruleForm.d1_occupation === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_occupation')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.income')" prop="income" style="margin-left:50px"
                  v-if="ruleForm.d1_occupation === 'パート'　|| ruleForm.d1_occupation === '年金受給者' ">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_income" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.income')"></el-input>
                </el-form-item>

                <el-form-item prop="school_year" v-if="ruleForm.d1_occupation === '高・大学生' " style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_school_year" size="mini"
                    style="margin-left:10px;width: 100px" placeholder="00"></el-input>
                  &emsp13; {{$t("healthIns5.grade")}}
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.income')" prop="income" v-if="ruleForm.d1_occupation === 'その他'"
                  style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_income" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.income')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d1_applicate_type === '非該当' || ruleForm.d1_applicate_type === '変更'  ">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium;margin-left:50px;">***{{$t("healthIns5.not_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d1_applicate_type === '非該当' || ruleForm.d1_applicate_type === '変更'  ">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.d_change_date')" prop="become_date" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d1_become_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 160px" type="date" :placeholder="$t('healthIns5.d_change_date')">
                  </el-date-picker>
                  <el-button class="el-icon-info" type="text" @click="s_change_date_hint"></el-button>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_reason" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in d_change_reason" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d1_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d1_oversea === '海外特例要件該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium; margin-left:50px;">***{{$t("healthIns5.oversea_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d1_oversea === '海外特例要件該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_oversea_reason" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea_become_reason" :key="item.id" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d1_oversea_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_oversea_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d1_oversea === '海外特例要件非該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium; margin-left:50px;">***{{$t("healthIns5.oversea_not_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d1_oversea === '海外特例要件非該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d1_oversea_reason" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea_change_reason" :key="item.id" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d1_oversea_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d1_oversea_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.domestic_transfer_date')" prop="oversea_transfer_date"
                  　v-if="ruleForm.d1_oversea_reason === '国内転'" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d1_oversea_transfer_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date"
                    :placeholder="$t('healthIns5.domestic_transfer_date')"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--Dependent2 Input -->
          <el-collapse-item :title="$t('healthIns5.dependent2')" name="4" style="margin-left:10px">
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.ins_last_name')" prop="d_last_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_name_last" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_last_name')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.ins_last_name_pho')" prop="d_last_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_name_last_frgn" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_last_name_pho')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.birthday')" prop="d_birthday" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d2_birthday" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns5.birthday')">
                  </el-date-picker>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.address')" prop="together" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_together" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in together" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.type')" prop="applicate_type" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_applicate_type" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in applicate_type" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.ins_first_name')" prop="d_first_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_name_first" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_first_name')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.ins_first_name_pho')" prop="d_first_name" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_name_first_frgn" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.ins_first_name_pho')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.gender')" prop="gender" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_gender" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in gender" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-if="ruleForm.d2_relation !==''　|| ruleForm.d2_together !== '別居' ">
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.postal_code')" prop="post" 　v-if="ruleForm.d2_together === '別居' "
                  style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_post" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.postal_code')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.oversea_type')" prop="oversea" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_oversea" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.remark')" prop="remark" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_remark" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.remark')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.relation')" prop="relation" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_relation" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in d_relation" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.address')" prop="address" 　v-if="ruleForm.d2_together === '別居'"
                  style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_address" type="textarea" :rows="4"
                    size="mini" style="margin-left:10px;width: 185px;" :placeholder="$t('healthIns5.address')">
                  </el-input>
                </el-form-item>

                <el-form-item v-if="ruleForm.d2_together !== '別居' ">
                  <span>
                    <br />
                  </span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d2_applicate_type === '該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium; margin-left:50px;">***{{$t("healthIns5.applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d2_applicate_type === '該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.d_become_date')" prop="become_date" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d2_become_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 160px" type="date" :placeholder="$t('healthIns5.d_become_date')">
                  </el-date-picker>
                  <el-button class="el-icon-info" type="text" @click="s_become_date_hint"></el-button>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_reason" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in d_become_reason" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.employed')" prop="occupation" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_occupation" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in d_occupation" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item v-if="ruleForm.d2_reason !== 'その他'">
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d2_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.other_occupation')" prop="other_occupation"
                  v-if="ruleForm.d2_occupation === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_occupation')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.income')" prop="income" style="margin-left:50px"
                  v-if="ruleForm.d2_occupation === 'パート'　|| ruleForm.d2_occupation === '年金受給者' ">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_income" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.income')"></el-input>
                </el-form-item>

                <el-form-item prop="school_year" v-if="ruleForm.d2_occupation === '高・大学生' " style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_school_year" size="mini"
                    style="margin-left:10px;width: 100px" placeholder="00"></el-input>
                  &emsp13; {{$t("healthIns5.grade")}}
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>
                <el-form-item>
                  <span>
                    <br />
                  </span>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.income')" prop="income" v-if="ruleForm.d2_occupation === 'その他'"
                  style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_income" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.income')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d2_applicate_type === '非該当' || ruleForm.d2_applicate_type === '変更'  ">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium; margin-left:50px;">***{{$t("healthIns5.not_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d2_applicate_type === '非該当' || ruleForm.d2_applicate_type === '変更'  ">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.d_change_date')" prop="become_date" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d2_become_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 160px" type="date" :placeholder="$t('healthIns5.d_change_date')">
                  </el-date-picker>
                  <el-button class="el-icon-info" type="text" @click="s_change_date_hint"></el-button>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_reason" clearable style="margin-left:10px;width: 185px" size="mini"
                    :placeholder="$t('general.select')">
                    <el-option v-for="item in d_change_reason" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d2_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d2_oversea === '海外特例要件該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium;margin-left:50px;">***{{$t("healthIns5.oversea_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d2_oversea === '海外特例要件該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_oversea_reason" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea_become_reason" :key="item.id" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d1_oversea_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_oversea_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row align="center" v-if="ruleForm.d2_oversea === '海外特例要件非該当'">
              <span
                style="color: rgb(224, 13, 13); font-weight: 200px; font-size: medium;margin-left:50px;">***{{$t("healthIns5.oversea_not_applicable_note")}}</span>
            </el-row>

            <el-row v-if="ruleForm.d2_oversea === '海外特例要件非該当'">
              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.reason')" prop="reason" style="margin-left:50px">
                  <el-select v-model="ruleForm.d2_oversea_reason" clearable style="margin-left:10px;width: 185px"
                    size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in oversea_change_reason" :key="item.id" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('healthIns5.other_reason')" prop="other_reason"
                  v-if="ruleForm.d2_oversea_reason === 'その他'" style="margin-left:50px">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.d2_oversea_other_reason" size="mini"
                    style="margin-left:10px;width: 185px" :placeholder="$t('healthIns5.other_reason')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('healthIns5.domestic_transfer_date')" prop="oversea_transfer_date"
                  　v-if="ruleForm.d2_oversea_reason === '国内転'" style="margin-left:50px">
                  <el-date-picker v-model="ruleForm.d2_oversea_transfer_date" size="mini" value-format="yyyy-MM-dd"
                    style="margin-left:10px;width: 185px" type="date"
                    :placeholder="$t('healthIns5.domestic_transfer_date')"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <br />
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        labelPosition: "left",
        value: "",
        empList: [{
          id: "",
          employee_id: "",
          name: "",
          name_rm: "",
          name_frgn: "",
          mynum: "",
          birthday: "",
          emp_insuranceID: "",
          post_code: "",
          address1: "",
          address2: "",
          address3: "",
          emp_ins_begin_day: "",
          gender: ""
        }],
        empList1: [],
        ruleForm: {
          id: "",
          apply_date: "",
          reference_no: "",
          income: "",
          s_to2: false,
          s_send_date: "",
          s_together: "",
          s_post: "",
          s_address: "",
          s_relation: "",
          s_name: "",
          s_name_frgn: "",
          s_birthday: "",
          s_mynum: "",
          s_country: "",
          s_foreigner_name_frgn: "",
          s_foreigner_name: "",
          s_tel_type: "",
          s_tel: "",
          s_applicate_type: "",
          s_become_date: "",
          s_reason: "",
          s_other_reason: "",
          s_death_date: "",
          s_occupation: "",
          s_other_occupation: "",
          s_income: "",
          s_oversea: "",
          s_oversea_date: "",
          s_oversea_reason: "",
          s_oversea_other_reason: "",
          s_oversea_transfer_date: "",
          s_remark: "",

          d1_name_first: "",
          d1_name_last: "",
          d1_name_first_frgn: "",
          d1_name_last_frgn: "",
          d1_birthday: "",
          d1_gender: "",

          d1_together: "",
          d1_post: "",
          d1_address: "",
          d1_relation: "",
          d1_other_relation: "",
          d1_mynum: "",
          d1_applicate_type: "",
          d1_become_date: "",
          d1_reason: "",
          d1_other_reason: "",
          d1_occupation: "",
          d1_school_year: "",
          d1_other_occupation: "",
          d1_income: "",
          d1_oversea: "",
          d1_oversea_reason: "",
          d1_oversea_other_reason: "",
          d1_oversea_transfer_date: "",
          d1_remark: "",

          d2_name_first: "",
          d2_name_last: "",
          d2_name_first_frgn: "",
          d2_name_last_frgn: "",
          d2_birthday: "",
          d2_gender: "",

          d2_together: "",
          d2_post: "",
          d2_address: "",
          d2_relation: "",
          d2_other_relation: "",
          d2_mynum: "",
          d2_applicate_type: "",
          d2_become_date: "",
          d2_reason: "",
          d2_other_reason: "",
          d2_occupation: "",
          d2_school_year: "",
          d2_other_occupation: "",
          d2_income: "",
          d2_oversea: "",
          d2_oversea_reason: "",
          d2_oversea_other_reason: "",
          d2_oversea_transfer_date: "",
          d2_remark: "",

          employee_id: "",

          name: "",
          name_rm: "",
          name_frgn: "",
          mynum: "",
          birthday: "",
          emp_insuranceID: "",
          post_code: "",
          address1: "",
          address2: "",
          address3: ""
        },
        together: [{
          value: "同居",
          label: this.$t("healthIns5.together")
        },
        {
          value: "別居",
          label: this.$t("healthIns5.seperate")
        }
        ],
        tel_type: [{
          value: "自宅",
          label: this.$t("healthIns5.home")
        },
        {
          value: "携帯",
          label: this.$t("healthIns5.mobile")
        },
        {
          value: "勤務先",
          label: this.$t("healthIns5.work")
        },
        {
          value: "その他",
          label: this.$t("healthIns5.other")
        }
        ],
        applicate_type: [{
          value: "該当",
          label: this.$t("healthIns5.applicable")
        },
        {
          value: "非該当",
          label: this.$t("healthIns5.not_applicable")
        },
        {
          value: "変更",
          label: this.$t("healthIns5.change")
        }
        ],
        oversea: [{
          value: "海外特例要件該当",
          label: this.$t("healthIns5.oversea_applicable")
        },
        {
          value: "海外特例要件非該当",
          label: this.$t("healthIns5.oversea_not_applicable")
        }
        ],
        s_relation: [{
          value: "夫",
          label: this.$t("healthIns5.husband")
        },
        {
          value: "妻",
          label: this.$t("healthIns5.wife")
        },
        {
          value: "夫（夫届）",
          label: this.$t("healthIns5.husband_fund")
        },
        {
          value: "妻（妻届）",
          label: this.$t("healthIns5.wife_fund")
        }
        ],
        d_relation: [{
          value: "実子・養子",
          label: this.$t("healthIns5.child")
        },
        {
          value: "実子・養子以外の子",
          label: this.$t("healthIns5.other_child")
        },
        {
          value: "父母・養父母",
          label: this.$t("healthIns5.parent")
        },
        {
          value: "義父母",
          label: this.$t("healthIns5.in_law")
        },
        {
          value: "弟妹",
          label: this.$t("healthIns5.younger_sibling")
        },
        {
          value: "兄姉",
          label: this.$t("healthIns5.elder_sibling")
        },
        {
          value: "祖父母",
          label: this.$t("healthIns5.grand_parent")
        },
        {
          value: "曽祖父母",
          label: this.$t("healthIns5.great_grand_parent")
        },
        {
          value: "孫",
          label: this.$t("healthIns5.grand_child")
        },
        {
          value: "その他",
          label: this.$t("healthIns5.other")
        }
        ],
        s_occupation: [{
          value: "無職",
          label: this.$t("healthIns5.unemployed")
        },
        {
          value: "パート",
          label: this.$t("healthIns5.part_time")
        },
        {
          value: "年金受給者",
          label: this.$t("healthIns5.pensioner")
        },
        {
          value: "その他",
          label: this.$t("healthIns5.other")
        }
        ],
        d_occupation: [{
          value: "無職",
          label: this.$t("healthIns5.unemployed")
        },
        {
          value: "パート",
          label: this.$t("healthIns5.part_time")
        },
        {
          value: "年金受給者",
          label: this.$t("healthIns5.pensioner")
        },
        {
          value: "小・中学生以下",
          label: this.$t("healthIns5.elementary")
        },
        {
          value: "高・大学生",
          label: this.$t("healthIns5.high")
        },
        {
          value: "その他",
          label: this.$t("healthIns5.other")
        }
        ],
        oversea_become_reason: [{
          value: "留学",
          label: this.$t("healthIns5.study_abroad")
        },
        {
          value: "同行家族",
          label: this.$t("healthIns5.acc_family")
        },
        {
          value: "特定活動",
          label: this.$t("healthIns5.specific")
        },
        {
          value: "海外婚姻",
          label: this.$t("healthIns5.oversea_marriage")
        },
        {
          value: "その他",
          label: this.$t("healthIns5.other")
        }
        ],
        oversea_change_reason: [{
          value: "国内転",
          label: this.$t("healthIns5.domestic_transfer")
        },
        {
          value: "その他",
          label: this.$t("healthIns5.other")
        }
        ],
        s_become_reason: [{
          value: "配偶者の就職",
          label: this.$t("healthIns5.s_occupation")
        },
        {
          value: "婚姻",
          label: this.$t("healthIns5.marriage")
        },
        {
          value: "離職",
          label: this.$t("healthIns5.leave_job")
        },
        {
          value: "収入減少",
          label: this.$t("healthIns5.income_decrease")
        },
        {
          value: "その他",
          label: this.$t("healthIns5.other")
        }
        ],
        s_change_reason: [{
          value: "死亡",
          label: this.$t("healthIns5.death")
        },
        {
          value: "離婚",
          label: this.$t("healthIns5.divorce")
        },
        {
          value: "就職・収入増加",
          label: this.$t("healthIns5.income_increase")
        },
        {
          value: "75歳到達",
          label: this.$t("healthIns5.age_75")
        },
        {
          value: "障害認定",
          label: this.$t("healthIns5.failure")
        },
        {
          value: "その他",
          label: this.$t("healthIns5.other")
        }
        ],
        d_become_reason: [{
          value: "出生",
          label: this.$t("healthIns5.birth")
        },
        {
          value: "離職",
          label: this.$t("healthIns5.employed")
        },
        {
          value: "収入減",
          label: this.$t("healthIns5.d_income_decrease")
        },
        {
          value: "同居",
          label: this.$t("healthIns5.together")
        },
        {
          value: "その他",
          label: this.$t("healthIns5.other")
        }
        ],
        d_change_reason: [{
          value: "死亡",
          label: this.$t("healthIns5.death")
        },
        {
          value: "就職",
          label: this.$t("healthIns5.d_employed")
        },
        {
          value: "収入増加",
          label: this.$t("healthIns5.d_income_increase")
        },
        {
          value: "75歳到達",
          label: this.$t("healthIns5.age_75")
        },
        {
          value: "障害認定",
          label: this.$t("healthIns5.failure")
        },
        {
          value: "その他",
          label: this.$t("healthIns5.other")
        }
        ],
        gender: [{
          value: "男",
          label: this.$t("healthIns5.male")
        },
        {
          value: "女",
          label: this.$t("healthIns5.female")
        }
        ],
        rules: {
          s_tel: [{
            trigger: "blur",
            pattern: /^(?:|\d{3}-\d{3}-\d{4}|\d{2}-\d{4}-\d{4}|\d{3}-\d{4}-\d{4})$/,
            message: this.$t("companyInfo.filltel"),
          },],
          apply_date: [
            {
              required: true,
              message: "年月日を選択してください",
              trigger: "blur",
            },
          ],

        },
        tableData: [],
        search: "",
        dialogVisible: false,
        dialogUpdate: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false
      };
    },
    methods: {
      handleToMoney() {
        if (this.ruleForm.income != null && this.ruleForm.income != "") {
          if (this.ruleForm.income.indexOf(",") != -1) {
            this.ruleForm.income = String(this.ruleForm.income);
            this.ruleForm.income = Number(this.ruleForm.income.split(",").join(""));
          }
          this.ruleForm.income = Number(this.ruleForm.income).toLocaleString();
        }
      },
      preview(index, row) {
        var uid = window.localStorage.getItem('LoginUserId');
        window.open("/pdf/健康保険　被扶養者（異動）届（国民年金第3号被保険者関係届）-" + "uid=" + uid + ".pdf");
      },
      referenceHint() {
        this.$notify.info({
          title: this.$t("healthIns5.reference_no"),
          message: this.$t("healthIns5.reference_noHint")
        });
      },
      s_become_date_hint() {
        this.$notify.info({
          title: this.$t("healthIns5.d_become_date"),
          message: this.$t("healthIns5.become_dateHint")
        });
      },
      s_change_date_hint() {
        this.$notify.info({
          title: this.$t("healthIns5.d_change_date"),
          message: this.$t("healthIns5.change_dateHint")
        });
      },
      employeeIdSelected() {
        // console.log(this.ruleForm.employee_id);
        let postData = this.qs.stringify({
          employee_id: this.ruleForm.employee_id
        });
        this.axios({
          method: "post",
          url: "/ListEmpList",
          data: postData
        })
          .then(response => {
            // console.log(response.data);
            this.empList1 = response.data;
            this.emp = this.empList1[0];
            this.ruleForm.name = this.emp.name;
            this.ruleForm.name_rm = this.emp.name_rm;
            this.ruleForm.mynum = this.emp.mynum;
            this.ruleForm.birthday = this.emp.birthday;
            this.ruleForm.emp_insuranceID = this.emp.emp_insuranceID;
            this.ruleForm.post_code = this.emp.post_code;
            this.ruleForm.address1 = this.emp.address1;
            this.ruleForm.address2 = this.emp.address2;
            this.ruleForm.address3 = this.emp.address3;
            this.ruleForm.emp_ins_begin_day = this.emp.emp_ins_begin_day;
            this.ruleForm.gender = this.emp.gender;
          })
          .catch(error => {
            console.log(error);
          });
      },
      printPDF(index, row) {
        let postData = this.qs.stringify({
          id: row.id
        });
        this.axios({
          method: "post",
          url: "/healthIns5PDF",
          data: postData
        })
          .then(response => {
            this.handleCurrentChange();
            this.$message({
              type: "success",
              message: this.$t("general.print_completed")
            });
            setTimeout(() => {
              this.preview(index, row);
            }, 700);
            // console.log(response);
          })
          .catch(error => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed")
            });
            console.log(error);
          });
      },
      handleEdit(index, row) {
        this.dialogUpdate = true;
        this.ruleForm = Object.assign({}, row);
      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: this.$t("general.confirm"),
          cancelButtonText: this.$t("general.cancel"),
          type: "warning"
        })
          .then(_ => {
            this.emptyUserData();
            done();
          })
          .catch(_ => { });
      },
      handleDelete(index, row) {
        // console.log(index, row);
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: "OK",
          cancelButtonText: this.$t("general.cancel"),
          type: "warning"
        })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id
            });
            this.axios({
              method: "post",
              url: "/deleteHealthIns5",
              data: postData
            })
              .then(response => {
                this.getPages();
                this.currentPage = 1;
                this.axios
                  .post("/pageHealthIns5")
                  .then(response => {
                    this.tableData = response.data;
                  })
                  .catch(error => {
                    console.log(error);
                  });
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed")
                });
                // console.log(response);
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled")
            });
          });
      },
      handleCurrentChange() {
        // console.log(`this.$t("general.current_page"): ${this.currentPage}`);
        let postData = this.qs.stringify({
          page: this.currentPage
        });
        this.axios({
          method: "post",
          url: "/pageHealthIns5",
          data: postData
        })
          .then(response => {
            this.tableData = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      s1_cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.emptyUserData();
        this.$refs[ruleForm].resetFields();
      },
      cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.emptyUserData();
      },
      emptyUserData() {
        this.ruleForm = {
          id: "",
          apply_date: "",
          reference_no: "",
          income: "",
          s_to2: false,
          s_send_date: "",
          s_together: "",
          s_post: "",
          s_address: "",
          s_relation: "",
          s_name: "",
          s_name_frgn: "",
          s_birthday: "",
          s_mynum: "",
          s_country: "",
          s_foreigner_name_frgn: "",
          s_foreigner_name: "",
          s_tel_type: "",
          s_tel: "",
          s_applicate_type: "",
          s_become_date: "",
          s_reason: "",
          s_other_reason: "",
          s_death_date: "",
          s_occupation: "",
          s_other_occupation: "",
          s_income: "",
          s_oversea: "",
          s_oversea_date: "",
          s_oversea_reason: "",
          s_oversea_other_reason: "",
          s_oversea_transfer_date: "",
          s_remark: "",

          d1_name_first: "",
          d1_name_last: "",
          d1_name_first_frgn: "",
          d1_name_last_frgn: "",
          d1_birthday: "",
          d1_gender: "",

          d1_together: "",
          d1_post: "",
          d1_address: "",
          d1_relation: "",
          d1_other_relation: "",
          d1_mynum: "",
          d1_applicate_type: "",
          d1_become_date: "",
          d1_reason: "",
          d1_other_reason: "",
          d1_occupation: "",
          d1_school_year: "",
          d1_other_occupation: "",
          d1_income: "",
          d1_oversea: "",
          d1_oversea_reason: "",
          d1_oversea_other_reason: "",
          d1_oversea_transfer_date: "",
          d1_remark: "",

          d2_name_first: "",
          d2_name_last: "",
          d2_name_first_frgn: "",
          d2_name_last_frgn: "",
          d2_birthday: "",
          d2_gender: "",

          d2_together: "",
          d2_post: "",
          d2_address: "",
          d2_relation: "",
          d2_other_relation: "",
          d2_mynum: "",
          d2_applicate_type: "",
          d2_become_date: "",
          d2_reason: "",
          d2_other_reason: "",
          d2_occupation: "",
          d2_school_year: "",
          d2_other_occupation: "",
          d2_income: "",
          d2_oversea: "",
          d2_oversea_reason: "",
          d2_oversea_other_reason: "",
          d2_oversea_transfer_date: "",
          d2_remark: "",
          employee_id: "",

          name: "",
          name_rm: "",
          name_frgn: "",
          mynum: "",
          birthday: "",
          emp_insuranceID: "",
          post_code: "",
          address1: "",
          address2: "",
          address3: ""


        };
      },
      addUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              apply_date: this.ruleForm.apply_date,
              reference_no: this.ruleForm.reference_no,
              income: this.ruleForm.income,
              s_to2: this.ruleForm.s_to2,
              s_send_date: this.ruleForm.s_send_date,
              s_together: this.ruleForm.s_together,
              s_post: this.ruleForm.s_post,
              s_address: this.ruleForm.s_address,
              s_relation: this.ruleForm.s_relation,
              s_name: this.ruleForm.s_name,
              s_name_frgn: this.ruleForm.s_name_frgn,
              s_birthday: this.ruleForm.s_birthday,
              s_mynum: this.ruleForm.s_mynum,
              s_country: this.ruleForm.s_country,
              s_foreigner_name_frgn: this.ruleForm.s_foreigner_name_frgn,
              s_foreigner_name: this.ruleForm.s_foreigner_name,
              s_tel_type: this.ruleForm.s_tel_type,
              s_tel: this.ruleForm.s_tel,
              s_applicate_type: this.ruleForm.s_applicate_type,
              s_become_date: this.ruleForm.s_become_date,
              s_reason: this.ruleForm.s_reason,
              s_other_reason: this.ruleForm.s_other_reason,
              s_death_date: this.ruleForm.s_death_date,
              s_occupation: this.ruleForm.s_occupation,
              s_other_occupation: this.ruleForm.s_other_occupation,
              s_income: this.ruleForm.s_income,
              s_oversea: this.ruleForm.s_oversea,
              s_oversea_date: this.ruleForm.s_oversea_date,
              s_oversea_reason: this.ruleForm.s_oversea_reason,
              s_oversea_other_reason: this.ruleForm.s_oversea_other_reason,
              s_oversea_transfer_date: this.ruleForm.s_oversea_transfer_date,
              s_remark: this.ruleForm.s_remark,

              d1_name_first: this.ruleForm.d1_name_first,
              d1_name_last: this.ruleForm.d1_name_last,
              d1_name_first_frgn: this.ruleForm.d1_name_first_frgn,
              d1_name_last_frgn: this.ruleForm.d1_name_last_frgn,
              d1_birthday: this.ruleForm.d1_birthday,
              d1_gender: this.ruleForm.d1_gender,

              d1_together: this.ruleForm.d1_together,
              d1_post: this.ruleForm.d1_post,
              d1_address: this.ruleForm.d1_address,
              d1_relation: this.ruleForm.d1_relation,
              d1_other_relation: this.ruleForm.d1_other_relation,
              d1_mynum: this.ruleForm.d1_mynum,
              d1_applicate_type: this.ruleForm.d1_applicate_type,
              d1_become_date: this.ruleForm.d1_become_date,
              d1_reason: this.ruleForm.d1_reason,
              d1_other_reason: this.ruleForm.d1_other_reason,
              d1_occupation: this.ruleForm.d1_occupation,
              d1_school_year: this.ruleForm.d1_school_year,
              d1_other_occupation: this.ruleForm.d1_other_occupation,
              d1_income: this.ruleForm.d1_income,
              d1_oversea: this.ruleForm.d1_oversea,
              d1_oversea_reason: this.ruleForm.d1_oversea_reason,
              d1_oversea_other_reason: this.ruleForm.d1_oversea_other_reason,
              d1_oversea_transfer_date: this.ruleForm.d1_oversea_transfer_date,
              d1_remark: this.ruleForm.d1_remark,

              d2_name_first: this.ruleForm.d2_name_first,
              d2_name_last: this.ruleForm.d2_name_last,
              d2_name_first_frgn: this.ruleForm.d2_name_first_frgn,
              d2_name_last_frgn: this.ruleForm.d2_name_last_frgn,
              d2_birthday: this.ruleForm.d2_birthday,
              d2_gender: this.ruleForm.d2_gender,

              d2_together: this.ruleForm.d2_together,
              d2_post: this.ruleForm.d2_post,
              d2_address: this.ruleForm.d2_address,
              d2_relation: this.ruleForm.d2_relation,
              d2_other_relation: this.ruleForm.d2_other_relation,
              d2_mynum: this.ruleForm.d2_mynum,
              d2_applicate_type: this.ruleForm.d2_applicate_type,
              d2_become_date: this.ruleForm.d2_become_date,
              d2_reason: this.ruleForm.d2_reason,
              d2_other_reason: this.ruleForm.d2_other_reason,
              d2_occupation: this.ruleForm.d2_occupation,
              d2_school_year: this.ruleForm.d2_school_year,
              d2_other_occupation: this.ruleForm.d2_other_occupation,
              d2_income: this.ruleForm.d2_income,
              d2_oversea: this.ruleForm.d2_oversea,
              d2_oversea_reason: this.ruleForm.d2_other_reason,
              d2_oversea_other_reason: this.ruleForm.d2_oversea_other_reason,
              d2_oversea_transfer_date: this.ruleForm.d2_oversea_transfer_date,
              d2_remark: this.ruleForm.d2_remark,

              employee_id: this.ruleForm.employee_id
            });
            this.axios({
              method: "post",
              url: "/insertHealthIns5",
              data: postData
            })
              .then(response => {
                this.axios
                  .post("/pageHealthIns5")
                  .then(response => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed")
                    });
                  })
                  .catch(error => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.add_failed")
                    });
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
                // console.log(response);
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      updateUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,

              apply_date: this.ruleForm.apply_date,
              reference_no: this.ruleForm.reference_no,
              income: this.ruleForm.income,
              s_to2: this.ruleForm.s_to2,
              s_send_date: this.ruleForm.s_send_date,
              s_together: this.ruleForm.s_together,
              s_post: this.ruleForm.s_post,
              s_address: this.ruleForm.s_address,
              s_relation: this.ruleForm.s_relation,
              s_name: this.ruleForm.s_name,
              s_name_frgn: this.ruleForm.s_name_frgn,
              s_birthday: this.ruleForm.s_birthday,
              s_mynum: this.ruleForm.s_mynum,
              s_country: this.ruleForm.s_country,
              s_foreigner_name_frgn: this.ruleForm.s_foreigner_name_frgn,
              s_foreigner_name: this.ruleForm.s_foreigner_name,
              s_tel_type: this.ruleForm.s_tel_type,
              s_tel: this.ruleForm.s_tel,
              s_applicate_type: this.ruleForm.s_applicate_type,
              s_become_date: this.ruleForm.s_become_date,
              s_reason: this.ruleForm.s_reason,
              s_other_reason: this.ruleForm.s_other_reason,
              s_death_date: this.ruleForm.s_death_date,
              s_occupation: this.ruleForm.s_occupation,
              s_other_occupation: this.ruleForm.s_other_occupation,
              s_income: this.ruleForm.s_income,
              s_oversea: this.ruleForm.s_oversea,
              s_oversea_date: this.ruleForm.s_oversea_date,
              s_oversea_reason: this.ruleForm.s_oversea_reason,
              s_oversea_other_reason: this.ruleForm.s_oversea_other_reason,
              s_oversea_transfer_date: this.ruleForm.s_oversea_transfer_date,
              s_remark: this.ruleForm.s_remark,

              d1_name_first: this.ruleForm.d1_name_first,
              d1_name_last: this.ruleForm.d1_name_last,
              d1_name_first_frgn: this.ruleForm.d1_name_first_frgn,
              d1_name_last_frgn: this.ruleForm.d1_name_last_frgn,
              d1_birthday: this.ruleForm.d1_birthday,
              d1_gender: this.ruleForm.d1_gender,

              d1_together: this.ruleForm.d1_together,
              d1_post: this.ruleForm.d1_post,
              d1_address: this.ruleForm.d1_address,
              d1_relation: this.ruleForm.d1_relation,
              d1_other_relation: this.ruleForm.d1_other_relation,
              d1_mynum: this.ruleForm.d1_mynum,
              d1_applicate_type: this.ruleForm.d1_applicate_type,
              d1_become_date: this.ruleForm.d1_become_date,
              d1_reason: this.ruleForm.d1_reason,
              d1_other_reason: this.ruleForm.d1_other_reason,
              d1_occupation: this.ruleForm.d1_occupation,
              d1_school_year: this.ruleForm.d1_school_year,
              d1_other_occupation: this.ruleForm.d1_other_occupation,
              d1_income: this.ruleForm.d1_income,
              d1_oversea: this.ruleForm.d1_oversea,
              d1_oversea_reason: this.ruleForm.d1_oversea_reason,
              d1_oversea_other_reason: this.ruleForm.d1_oversea_other_reason,
              d1_oversea_transfer_date: this.ruleForm.d1_oversea_transfer_date,
              d1_remark: this.ruleForm.d1_remark,

              d2_name_first: this.ruleForm.d2_name_first,
              d2_name_last: this.ruleForm.d2_name_last,
              d2_name_first_frgn: this.ruleForm.d2_name_first_frgn,
              d2_name_last_frgn: this.ruleForm.d2_name_last_frgn,
              d2_birthday: this.ruleForm.d2_birthday,
              d2_gender: this.ruleForm.d2_gender,

              d2_together: this.ruleForm.d2_together,
              d2_post: this.ruleForm.d2_post,
              d2_address: this.ruleForm.d2_address,
              d2_relation: this.ruleForm.d2_relation,
              d2_other_relation: this.ruleForm.d2_other_relation,
              d2_mynum: this.ruleForm.d2_mynum,
              d2_applicate_type: this.ruleForm.d2_applicate_type,
              d2_become_date: this.ruleForm.d2_become_date,
              d2_reason: this.ruleForm.d2_reason,
              d2_other_reason: this.ruleForm.d2_other_reason,
              d2_occupation: this.ruleForm.d2_occupation,
              d2_school_year: this.ruleForm.d2_school_year,
              d2_other_occupation: this.ruleForm.d2_other_occupation,
              d2_income: this.ruleForm.d2_income,
              d2_oversea: this.ruleForm.d2_oversea,
              d2_oversea_reason: this.ruleForm.d2_other_reason,
              d2_oversea_other_reason: this.ruleForm.d2_oversea_other_reason,
              d2_oversea_transfer_date: this.ruleForm.d2_oversea_transfer_date,
              d2_remark: this.ruleForm.d2_remark,

              employee_id: this.ruleForm.employee_id
            });
            this.axios({
              method: "post",
              url: "/updateHealthIns5",
              data: postData
            })
              .then(response => {
                this.handleCurrentChange();
                this.s1_cancel(ruleForm);
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed")
                });
                // console.log(response);
              })
              .catch(error => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.edit_failed")
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      getPages() {
        this.axios
          .post("/rowsHealthIns5")
          .then(response => {
            this.total = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      }
    },
    created() {
      this.axios
        .post("/pageHealthIns5")
        .then(response => {
          this.show = true
          this.tableData = response.data;
        })
        .catch(error => {
          this.show = false;
          this.$message({
            type: 'error',
            message: '開発中です。'
          });
          console.log(error);
        });

      this.axios
        .post("/rowsHealthIns5")
        .then(response => {
          this.total = response.data;
        })
        .catch(error => {
          console.log(error);
        });
      this.axios
        .post("/ListEmpListForInsNameChange")
        .then(response => {
          // console.log(response.data);
          this.empList = response.data;
          // console.log(this.empList);
        })
        .catch(error => {
          console.log(error);
        });
    }
  };
</script>


<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }
</style>
<style scoped>
  .search_name {
    width: 200px;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }

  .style1 {
    margin-right: 142px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/HealthIns/HealthIns5.vue